import { http, INSTITUTION_REFERENCE } from "@/lib/api";

const getPrimaryFundGroup = item => item.fundGroups?.[0] || {};

const mapSeva = item => {
  const fundGroup = getPrimaryFundGroup(item);

  return {
    id: String(item.sevaTypesId),
    name: item.displayName || item.name || "",
    description: item.description || item.displayName || item.name || "",
    category: fundGroup.fundGroup || "Seva",
    amount: Number(fundGroup.amount || 0),
    raw: item,
  };
};

export async function fetchSevas({
  sevaCategory = 1,
  index = 0,
  size = 1000,
  sort_by = "sevaTypesId",
  sort_order = "desc",
} = {}) {
  const response = await http.get("/shared/seva-types", {
    params: {
      institutionReference: INSTITUTION_REFERENCE,
      sevaCategory,
      index,
      size,
      sort_by,
      sort_order,
    },
  });

  return response?.data?.data?.results?.map(mapSeva) || [];
}

export async function fetchSevaById(sevaId, options = {}) {
  const sevas = await fetchSevas(options);
  return sevas.find(seva => String(seva.id) === String(sevaId)) || null;
}

export async function createSevaPayment(payload) {
  const response = await http.post("/shared/create-payment", {
    institutionReference: INSTITUTION_REFERENCE,
    gatewayId: 3,
    isDesktop: true,
    ...payload,
  });

  return response?.data;
}

export async function fetchSevaPaymentStatus(reference) {
  const response = await http.post("/shared/payment-status", { reference });
  return response?.data;
}
